import Header from "../components/Header";
import ContactForm from "../components/ContactForm";
import Info from "../components/Info";

export default function Contact() {
  return (
    <>
      <Header
        title="Contact"
        subtitle={
          <>
            If you're reaching out about <strong>Note Ninja</strong>,{" "}
            <strong>Record Health</strong>, or a potential collaboration, I'd
            love to hear from you. Use the form below or email me directly.
          </>
        }
      />
      <ContactForm />
      <Info />
    </>
  );
}
